<template>
  <v-layout :loading="loading">
    <template v-if="!loading">
      <d-header
        v-if="!$laravel.user.is_owner_contact && !$laravel.user.owner_id"
        fluid
        :actions="actions"
      >
        <h1 class="title">
          {{ model.name }}
        </h1>
      </d-header>

      <d-container fluid>
        <div
          v-if="!$laravel.user.is_owner_contact && !$laravel.user.owner_id"
          class="tabs is-left"
        >
          <ul>
            <li :class="{ 'is-active': $route.name === 'owners.show.details' }">
              <router-link :to="{ path: createTabsLinkPaths('', model.id) }">
                {{ $t("details").capitalize() }}
              </router-link>
            </li>
            <li
              :class="{
                'is-active': $route.name === 'owners.show.owner.businesses',
              }"
            >
              <router-link
                :to="{
                  path: createTabsLinkPaths('owner-businesses', model.id),
                  params: { owner_id: model.id },
                }"
              >
                {{ $t("owner_businesses").capitalize() }}
              </router-link>
            </li>
            <li
              :class="{ 'is-active': $route.name === 'owners.show.contacts' }"
            >
              <router-link
                :to="{
                  path: createTabsLinkPaths('contacts', model.id),
                  params: { owner_id: model.id },
                }"
              >
                {{ $t("owner_contacts").capitalize() }}
              </router-link>
            </li>
          </ul>
        </div>
        <router-view :model="model" />
      </d-container>
    </template>
  </v-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
      __owner: this.title, // for breadcrumb
    };
  },
  data() {
    return {
      current_tab: "details",
      model: {},
      billing_address: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    },
    actions() {
      if (
        this.$laravel.user.role == "employee" ||
        this.$laravel.user.is_owner_contact
      ) {
        return [];
      }
      return [
        {
          label: this.$t("edit"),
          resource: "owner",
          data: this.model,
          path: "/owners/" + this.model.id + "/edit",
          method: "update",
          primary: true,
          color: "is-grey",
          icon: "pencil",
        },
      ];
    },
    hasBreadcrumbs() {
      if (this.$laravel.user.is_owner_contact) {
        return false;
      }
      return true;
    },
  },
  watch: {
    $route(to, from) {
      this.current_tab = to.name === "contacts" ? "contacts" : "details";
    },
  },
  created() {
    this.current_tab = this.$route.name === "details" ? "details" : "contacts";
    this.$http
      .get(
        this.$laravel.route("api.owners.show", {
          owner: this.$route.params.owner,
        })
      )
      .then((response) => {
        this.loading = false;
        this.model = response.data.data;
      })
      .catch((e) => {
        console.error(e);
        this.$router.push("/owners");
      });
  },
  methods: {
    createTabsLinkPaths(tab_name, model_id) {
      return "/owners/" + model_id + "/" + tab_name;
    },
  },
};
</script>
